import { isValidTelUrl } from './is-valid-te-url.js';
import { linkify } from './linkify/linkify.js';

export const normalizeHref = (value: string): string | undefined => {
  if (isValidTelUrl(value)) {
    return value;
  }

  if (value.startsWith('mailto:')) {
    const [email, ...queryParts] = value.substring(7).split('?');
    const queryString = queryParts.join('?');
    const sanitizedQuery = queryString ? `?${new URLSearchParams(queryString).toString()}` : '';
    return `mailto:${email}${sanitizedQuery}`;
  }

  const [urlValue, anchor] = value.split('#');
  const normalizedUrl = urlValue && linkify.match(urlValue) && linkify.match(urlValue)?.[0]?.url;

  if (normalizedUrl === null) {
    return undefined;
  }

  return anchor ? `${normalizedUrl}#${anchor}` : normalizedUrl;
};
